import { useState } from "react";
import { useNavigate } from "react-router-dom";

const vehicleTypes = [
  { value: "all", label: "Todos os tipos" },
  { value: "Econômico", label: "Econômico" },
  { value: "SUV", label: "SUV" },
  { value: "Sedan", label: "Sedan" },
  { value: "Premium", label: "Premium" },
  { value: "Van", label: "Van" },
  { value: "Picape", label: "Picape" },
];

export default function HeroSection() {
  const navigate = useNavigate();
  const [type, setType] = useState("all");
  const [pickup, setPickup] = useState("");
  const [dropoff, setDropoff] = useState("");
  const [agency, setAgency] = useState("");

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (type !== "all") params.set("tipo", type);
    if (pickup) params.set("retirada", pickup);
    if (dropoff) params.set("devolucao", dropoff);
    if (agency) params.set("agencia", agency);
    navigate(`/busca?${params.toString()}`);
  };

  return (
    <section className="relative min-h-[90vh] flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4e2609b82b6f7b412dc6f1897b20831b.jpg"
          alt="Campinas cidade"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center px-4 pt-24 pb-12">
        {/* Location Badge */}
        <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 text-white text-sm font-medium px-4 py-2 rounded-full mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-map-pin-line text-orange-400"></i>
          </div>
          Campinas e Região
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-6xl font-extrabold text-white text-center leading-tight mb-4 max-w-4xl">
          Alugue seu veículo<br />
          <span className="text-orange-400">sem entrada</span>
        </h1>
        <p className="text-white/80 text-lg md:text-xl text-center mb-3 max-w-2xl">
          Apenas cadastro no app • Fatura paga pelo app da loja • 100% digital
        </p>
        <p className="text-white/60 text-sm text-center mb-10">
          Mais de 100 veículos disponíveis em Campinas e região
        </p>

        {/* Search Card */}
        <div className="w-full max-w-5xl bg-white rounded-2xl p-5 md:p-6 shadow-2xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            {/* Tipo */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Tipo de Veículo</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-car-line text-orange-500 text-sm"></i>
                </div>
                <select
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  className="w-full pl-9 pr-3 py-3 border border-gray-200 rounded-xl text-sm text-gray-700 bg-gray-50 focus:outline-none focus:border-orange-400 cursor-pointer appearance-none"
                >
                  {vehicleTypes.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Retirada */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Data de Retirada</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-calendar-line text-orange-500 text-sm"></i>
                </div>
                <input
                  type="date"
                  value={pickup}
                  onChange={(e) => setPickup(e.target.value)}
                  className="w-full pl-9 pr-3 py-3 border border-gray-200 rounded-xl text-sm text-gray-700 bg-gray-50 focus:outline-none focus:border-orange-400"
                />
              </div>
            </div>

            {/* Devolução */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Data de Devolução</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-orange-500 text-sm"></i>
                </div>
                <input
                  type="date"
                  value={dropoff}
                  onChange={(e) => setDropoff(e.target.value)}
                  className="w-full pl-9 pr-3 py-3 border border-gray-200 rounded-xl text-sm text-gray-700 bg-gray-50 focus:outline-none focus:border-orange-400"
                />
              </div>
            </div>

            {/* Agência */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Agência</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-2-line text-orange-500 text-sm"></i>
                </div>
                <select
                  value={agency}
                  onChange={(e) => setAgency(e.target.value)}
                  className="w-full pl-9 pr-3 py-3 border border-gray-200 rounded-xl text-sm text-gray-700 bg-gray-50 focus:outline-none focus:border-orange-400 cursor-pointer appearance-none"
                >
                  <option value="">Qualquer agência</option>
                  <option value="centro">Centro Campinas</option>
                  <option value="iguatemi">Shopping Iguatemi</option>
                  <option value="viracopos">Aeroporto Viracopos</option>
                  <option value="barao">Barão Geraldo</option>
                  <option value="hortolandia">Hortolândia</option>
                </select>
              </div>
            </div>
          </div>



          <button
            onClick={handleSearch}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 rounded-xl text-base transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-lg"></i>
            </div>
            Buscar Veículos
          </button>
        </div>
      </div>
    </section>
  );
}
